export default {
    main_menu: {
        home: 'Home',
        company: 'Company',
        my_companies: 'My companies',
        reservations: 'My reservations',
        timeline: 'Timeline',
        made: 'Made',
        received: 'Received',
        locations: 'Locations',
        locations_add: ' + Add location',
        my_calendar: 'My calendar',
        favorites: 'Favorites',
        offers: 'Services',
        contact: 'Contact',
        admin_reservations: 'Reservations',
        activate_member: 'Activate member',
    },
    user_menu: {
        profile: 'My Profile',
        go_to_admin_profile: 'Go back to admin profile',
        logout: 'Log out',
    },
    top_menu: {
        create_company: 'Create company',
        create_service: 'Create service',
        find_service: 'Find service',
        login: 'Login',
        find_offers: 'Find services...',
        create_user_offer: 'As user',
        create_company_offer: 'As company',
    },
}
